import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import stockService from "./stockService";

export const getPrivateStock = createAsyncThunk(
  "stocks/private",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      const response = await stockService.getPrivateStock(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  funds: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
};
export const mfSlice = createSlice({
  name: "stock",
  initialState,
  reducers: {
    resetState: (state) => initialState,
  },

  extraReducers: (builder) => {
    builder
      .addCase(getPrivateStock.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPrivateStock.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.funds = action.payload;
      })
      .addCase(getPrivateStock.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      });
  },
});

export const { resetState } = mfSlice.actions;
export default mfSlice.reducer;
